import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const AdminSettings = () => {
  const [profile, setProfile] = useState({
    name: "Admin Name",
    email: "admin@example.com",
    phone: "+91 9876543210",
  });

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    console.log("Saved settings:", profile);
    alert("Settings saved!");
  };

  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>

      <Tabs defaultValue="profile" className="w-full">
        <TabsList className="grid grid-cols-2 sm:grid-cols-4 w-full mb-4">
          <TabsTrigger value="profile">Profile</TabsTrigger>
          <TabsTrigger value="clinic">Clinic</TabsTrigger>
          <TabsTrigger value="staff">Staff & Roles</TabsTrigger>
          <TabsTrigger value="appointments">Appointments</TabsTrigger>
        </TabsList>

        {/* Profile Settings */}
        <TabsContent value="profile">
          <Card>
            <CardContent className="p-4 space-y-4">
              <h2 className="text-lg font-semibold">Profile Settings</h2>
              <Input
                name="name"
                value={profile.name}
                onChange={handleProfileChange}
                placeholder="Admin Name"
              />
              <Input
                name="email"
                value={profile.email}
                onChange={handleProfileChange}
                placeholder="Admin Email"
              />
              <Input
                name="phone"
                value={profile.phone}
                onChange={handleProfileChange}
                placeholder="Admin Phone"
              />
              <Button onClick={handleSave}>Save Changes</Button>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Clinic Settings */}
        <TabsContent value="clinic">
          <Card>
            <CardContent className="p-4 space-y-4">
              <h2 className="text-lg font-semibold">Clinic Settings</h2>
              <Input placeholder="Clinic Name" />
              <Input placeholder="Clinic Address" />
              <Input placeholder="Contact Info" />
              <Button>Save Changes</Button>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Staff & Roles */}
        <TabsContent value="staff">
          <Card>
            <CardContent className="p-4">
              <h2 className="text-lg font-semibold mb-2">Staff & Roles</h2>
              <p className="text-gray-600">Manage doctors, physiotherapists, and receptionists here.</p>
              <Button className="mt-4">Add Staff</Button>
            </CardContent>
          </Card>
        </TabsContent>

        {/* Appointment Settings */}
        <TabsContent value="appointments">
          <Card>
            <CardContent className="p-4">
              <h2 className="text-lg font-semibold mb-2">Appointment Settings</h2>
              <p className="text-gray-600">Configure booking rules, limits, and cancellation policies.</p>
              <Button className="mt-4">Update Rules</Button>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AdminSettings;
